import React from "react";
import { PropTypes } from "prop-types";
import { useNavigate } from "react-router-dom";
import { Link, Typography } from "@mui/material";

import { BOTTOM_BAR_HEIGHT } from "./BottomBar";
import { navigateWithAlert } from "../util/formHelpers";

/**
 *
 * @param {bool} [isFormDirty] if true, the form wrpping this header has unsaved changes
 * @param {object[]} [links] list of links to show to the right of the title
 * @param {string} [subtitle]
 * @param {string} title
 * @returns
 */
export default function Header({ isFormDirty, links = [], subtitle, title }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid="header"
      style={{
        height: "100%",
        marginBottom: "40px",
        marginTop: "20px",
        position: "relative",
        width: "100%",
      }}
    >
      <div
        style={{
          maxHeight: `calc(100% - ${BOTTOM_BAR_HEIGHT}px)`,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Typography variant="h4">{title}</Typography>
            <Typography variant="subtitle1" style={{ color: "grey" }}>
              {subtitle}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            {links.map(({ label, route, isButton = true }) => (
              <Link
                key={route}
                href={route}
                target="_blank"
                rel="noopener"
                component={isButton ? "button" : undefined}
                onClick={
                  isButton
                    ? (event) =>
                        navigateWithAlert({
                          event,
                          isFormDirty,
                          navigate,
                          route,
                        })
                    : undefined
                }
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  textAlign: "left",
                }}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  isFormDirty: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
    })
  ),
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};
